// utils/urlUtils.js
export const hasUrl = (text) => {
    if (!text || typeof text !== 'string') return false;
    
    // Регулярное выражение для URL
    const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/i;
    return urlRegex.test(text);
};



export const isUrl = (text) => {
    if (!text || typeof text !== 'string') return false;
    
    // Строгое выражение для валидации URL
    const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i;
    return urlRegex.test(text);
};

export const getUrlDomain = (url) => {
    try {
        const parsed = new URL(url);
        return parsed.hostname.replace('www.', '');
    } catch {
        return null;
    }
};